export const filterOption = (input: any, option: any) =>
  option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
